export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6766.d4af14ae.jpg";